import { commonArrowBtn } from '../../../common/common-use-arrow-btn';
import { builder } from '../../../../../../../common/js/configs';
import { commonCreativeConfig } from '../../common-creative-config';

export const formatConfigUnmarshaller = {
  ...commonArrowBtn,
  creative: builder.holder({
    url: commonCreativeConfig.url,
    creativeRatio: commonCreativeConfig.creativeRatio,
    objectFit: builder.string('creative_object_fit', {
      possibleValues: [
        {
          name: 'Cover',
          value: 'cover'
        },
        {
          name: 'Contain',
          value: 'contain'
        }
      ],
      defaultValue: 'contain'
    })
  })
};
